import React from "react";
import App from "./App.jsx";
import "./index.css";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import "@webcomponents/i2cwebcomponents/dist/themes/light.css";
import "@webcomponents/i2cwebcomponents/dist/themes/dark.css";
import { setBasePath } from "@webcomponents/i2cwebcomponents/dist/utilities/base-path";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
setBasePath("/static/dist");

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPCHA_SITE_KEY}
    >
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
